// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e2bdcdae","732":"d690af13"}[chunkId] + ".chunk.js";
};